import PropTypes from "prop-types"
import React, { useEffect, useRef, useState } from "react"
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Collapse,
  Container,
  Form,
  FormGroup,
  FormText,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Spinner,
  UncontrolledTooltip,
} from "reactstrap"

import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"

import { postUpdateStatusAR } from "../../services/orders/calls"

import Select from "react-select"

import Breadcrumb from "../../components/Common/Breadcrumb2"

import toast from "components/Toast/Toast"
import { formatarString, objectToQueryString } from "helpers"
import { useUser } from "hooks/useUser"
import moment from "moment"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit"
import { withTranslation } from "react-i18next"
import { Link, useHistory, useLocation } from "react-router-dom"
import { openSupport } from "services/support/calls"
import { courierClass, getBadgeClass } from "./constants"

import jwt from "jsonwebtoken"
import { getTemplatesByRoleId } from "services/exports/calls"
import { getStatusSafra } from "services/shipping-events/calls"

import DualListBox from "react-dual-listbox"
import "react-dual-listbox/lib/react-dual-listbox.css"
import {
  getCheckboxes,
  getOrderOptions,
  getOrders,
  postOrders,
  postReport,
  postReportFile,
} from "services/orders/tracking/calls"
import { isBefore } from "date-fns"

const { REACT_APP_MAX_LINES_EXPORT } = process.env || 10000

const limit = 20

const initPageOptions = {
  sizePerPage: limit,
  totalSize: 0,
  custom: true,
  showTotal: true,
  hideSizePerPage: true,
  hidePageListOnlyOnePage: true,
  prePageText: "Anterior",
  nextPageText: "Próximo",
  paginationTotalRenderer: () => {
    return (
      <div className="d-inline">
        <span className="react-bootstrap-table-pagination-total">
          Registros Retornados: {total}
        </span>
      </div>
    )
  },
}

const tipoChave = [
  { value: "cpf", label: "CPF (Default)" },
  { value: "arMestre", label: "AR" },
  { value: "centroCusto", label: "Centro de Custo" },
]

const Rastreio = props => {
  document.title = "Rastreio | Sensetek"
  moment.locale("pt-br")
  const { payload: user } = useUser()

  const [selectedDualList, setSelectedDualList] = useState([])

  const [exportModal, setExportModal] = useState(false)
  const [statues, setStatuses] = useState([])
  const [products, setProducts] = useState([])
  const [pageOptions, setPageOptions] = useState(initPageOptions)
  const [orders, setOrders] = useState([])
  const [total, setTotal] = useState(0)
  const [couriers, setCouriers] = useState([])
  const [UFs, setUFs] = useState([])
  const [factories, setFactories] = useState([])
  const [pages, setPages] = useState(1)
  const [isLoading, handleLoading] = useState(true)
  const [isFirstPage, setIsFirstPage] = useState(true)
  const [isLastPage, setIsLastPage] = useState(false)
  const [fileType, setFileType] = useState([])
  const [baseType, setBaseType] = useState([])
  const [checkboxes, setCheckboxes] = useState([])
  const [inputFile, setFile] = useState(null)
  const [query, setQuery] = useState({
    refKey: "",
    status: "",
    statusSafra: "",
    startAt: moment().startOf("month").toDate(),
    endAt: moment().toDate(),
    courierId: "",
    filterUF: "",
    filterFactories: "",
    cepInicio: "",
    cepFim: "",
    dateFilter: "emittedAt",
    boxFilterBy: "arMestre",
    fileFilterBy: "arMestre",
    onTime: null,
    clientName: "",
    product: "",
  })
  const [currentPage, setCurrentPage] = useState(1)
  const [templatesList, setTemplatesList] = useState([])

  const batchInputRef = useRef(null)

  let location = useLocation()
  let history = useHistory()

  const [statusSafra, setStatusSafra] = useState()

  const statusSafraOptions = statusSafra?.map(status => ({
    value: status.id,
    label: status.name,
  }))

  const statusOptions = statues?.map(status => ({
    value: status.id,
    label: status.name,
  }))

  const productsOptions = products?.map(prod => ({
    value: prod.id,
    label: `${prod.code} - ${prod.tag}`,
  }))

  const courierOptions = couriers?.map(courier => ({
    value: courier.id,
    label: courier.name,
  }))

  const ufOptions = UFs?.map(uf => ({
    value: uf.uf,
    label: uf.uf,
  }))

  const factoriesOptions = factories?.map(factory => ({
    value: factory.id,
    label: factory.name,
  }))

  const defaultSorted = [
    {
      dataField: "shippingTrackerCode",
      order: "asc",
    },
  ]

  const selectRow = {
    mode: "checkbox",
    hideSelectColumn: true,
  }

  const toggleModal = () => {
    setExportModal(!exportModal)
  }

  const generateExport = () => {
    const length = checkboxes.filter(checkbox => checkbox.checked).length
    if (selectedDualList?.length == 0) {
      toast(
        "warning",
        "Não é possível exportar um arquivo com nenhum campo selecionado.",
        ""
      )
      return false
    }
    if (inputFile) {
      fetchReportOrdersFile(query, fileType, baseType, inputFile)
    } else {
      fetchReportOrders(query, fileType, baseType)
    }
    setExportModal(false)
  }

  const fetchReportOrders = async (filters, fileType, baseType) => {
    let addToQueue = false
    if (total > REACT_APP_MAX_LINES_EXPORT) {
      addToQueue = true
    }
    const cbs = selectedDualList.map(sd => {
      return {
        ...checkboxes.filter(checkbox => checkbox.title == sd)[0],
      }
    })
    try {
      await postReport(
        filters || query,
        addToQueue,
        user.id,
        fileType,
        baseType,
        cbs,
        total
      )
      toast("success", "Pedido realizado com sucesso!", "Exportação")
    } catch (err) {
      console.error(err)
      toast("error", "Problema ao executar o pedido.", "Erro")
    } finally {
      handleLoading(false)
    }
  }

  const fetchReportOrdersFile = async (filters, fileType, baseType, file) => {
    try {
      let addToQueue = false
      if (total > REACT_APP_MAX_LINES_EXPORT) {
        addToQueue = true
      }
      if (file) {
        addToQueue = true
      }
      const cbs = selectedDualList.map(sd => {
        return {
          ...checkboxes.filter(checkbox => checkbox.title == sd)[0],
        }
      })
      await postReportFile(
        filters || query,
        { batch: file },
        addToQueue,
        user.id,
        fileType,
        baseType,
        cbs,
        total
      )
      toast("success", "Pedido realizado com sucesso!", "Exportação")
    } catch (error) {
      console.error(error)
      toast("error", "Problema ao executar o pedido.", "Erro")
    } finally {
      handleLoading(false)
    }
  }

  const columns = [
    {
      dataField: "shippingOrderCode",
      text: "Cod. Postagem",
      sort: false,
    },
    {
      dataField: "shippingTrackerCode",
      text: "Cod. Pesquisa",
      sort: false,
    },
    {
      dataField: "orderDetails",
      text: "Nome Cliente",
      sort: false,
      formatter: (cellContent, row) => {
        const clientName = row?.orderDetails?.[0]?.clientName || ""
        return formatarString(clientName, 30)
      },
    },
    {
      dataField: "shippingCompany.name",
      text: "Transportadora",
      sort: false,
      headerAlign: "center",
      align: "center",
      formatter: (cellContent, row) => {
        let badgeColor = {}
        badgeColor[courierClass[row?.shippingCompany?.id]] = true
        return (
          <span className={`badge ${courierClass[row?.shippingCompany?.id]}`}>
            {cellContent}
          </span>
        )
      },
    },
    {
      dataField: "currentAddress.state",
      text: "UF",
      sort: false,
      headerAlign: "center",
      align: "center",
    },
    {
      dataField: "emittedAt",
      text: "Dt. Pedido",
      headerAlign: "center",
      sort: false,
      align: "center",
      formatter: (cellContent, row) => {
        return cellContent ? (
          <b>{moment(cellContent, "YYYY-MM-DD").format("DD/MM/YYYY")}</b>
        ) : (
          "-"
        )
      },
    },
    {
      dataField: "factory.name",
      text: "Fábrica",
      sort: false,
    },
    {
      dataField: "currentStatus.name",
      text: "Situação Atual",
      sort: false,
      headerAlign: "center",
      align: "center",
      formatter: (cellContent, row) => {
        return (
          <span className={`badge ${getBadgeClass(row?.currentStatus?.id)}`}>
            {cellContent}
          </span>
        )
      },
    },
    {
      dataField: "expectedDeliveryAt",
      text: "Estimativa de Entrega",
      headerAlign: "center",
      sort: false,
      align: "center",
      formatter: (cellContent, row) => {
        return cellContent ? (
          <b>{moment(cellContent, "YYYY-MM-DD").format("DD/MM/YYYY")}</b>
        ) : (
          "-"
        )
      },
    },
    {
      dataField: "shippingDeliveryAt",
      text: "Prazo",
      headerAlign: "center",
      sort: false,
      align: "center",
      formatter: (cellContent, row) => {
        const shipping = cellContent ? new Date(cellContent) : new Date()
        const esperado = new Date(row?.expectedDeliveryAt)
        return isBefore(shipping, esperado) ? (
          <span className="badge bg-success">Dentro</span>
        ) : (
          <span className="badge bg-danger">Fora</span>
        )
      },
    },
    {
      dataField: "actions",
      isDummyField: true,
      text: "Ações",
      headerAlign: "center",
      align: "center",
      formatter: (cellContent, row) => (
        <ul className="list-unstyled hstack gap-1 mb-0 justify-content-center">
          <li data-bs-toggle="tooltip" data-bs-placement="top">
            <a
              to=""
              className={`btn btn-sm btn-info`}
              onClick={() => {
                updateStatusByAR(row.id)
              }}
            >
              <i className="mdi mdi-refresh" id={`updateTooltip${row.id}`}></i>
            </a>
            <UncontrolledTooltip
              placement="top"
              target={`updateTooltip${row.id}`}
            >
              Atualizar Status
            </UncontrolledTooltip>
          </li>
          <li data-bs-toggle="tooltip" data-bs-placement="top">
            <Link
              to={`/pedidos/${row.id}`}
              target="_blank"
              className={`btn btn-sm btn-primary`}
            >
              <i
                className="mdi mdi-eye-outline"
                id={`viewTooltip${row.id}`}
              ></i>
            </Link>
            <UncontrolledTooltip
              placement="top"
              target={`viewTooltip${row.id}`}
            >
              Visualizar
            </UncontrolledTooltip>
          </li>
          {jwt
            .decode(localStorage.getItem("token"))
            ?.roles.includes("atendimento") && (
            <li data-bs-toggle="tooltip" data-bs-placement="top">
              <a
                target="_blank"
                className={`btn btn-sm btn-secondary`}
                onClick={async () => {
                  const { payload } = await openSupport(row.shippingTrackerCode)
                  const { support } = payload
                  window.open(
                    `/atendimento/${support.uuid}?q=${row.shippingTrackerCode}`,
                    "_blank"
                  )
                }}
              >
                <i
                  className="mdi mdi-phone-in-talk-outline"
                  id={`attTooltip${row.id}`}
                ></i>
              </a>
              <UncontrolledTooltip
                placement="top"
                target={`attTooltip${row.id}`}
              >
                Atendimento
              </UncontrolledTooltip>
            </li>
          )}
        </ul>
      ),
    },
  ]

  const [selectedStatus, setselectedStatus] = useState([])

  const statusHandleChange = options => {
    let lista = options ? options.map(items => items.value) : []
    setselectedStatus(options)
    setQuery({
      ...query,
      status: lista.toString(),
    })
  }

  const statusSafraHandleChange = options => {
    let lista = options ? options.map(items => items.value) : []
    const statuses = statues
      .filter(s => lista.includes(s.statusSafraId))
      .map(ss => ss.id)
    setQuery({
      ...query,
      statusSafra: statuses.toString(),
    })
  }
  const productHandleChange = options => {
    let lista = options ? options.map(items => items.value) : []
    const produtos = products.filter(s => lista.includes(s.id)).map(ss => ss.id)
    setQuery({
      ...query,
      product: produtos.toString(),
    })
  }

  const courierHandleChange = options => {
    let lista = options ? options.map(items => items.value) : []
    setQuery({
      ...query,
      courierId: lista.toString(),
    })
  }

  const ufHandleChange = options => {
    let lista = options ? options.map(items => items.value) : []
    setQuery({
      ...query,
      filterUF: lista.toString(),
    })
  }
  const factoriesHandleChange = options => {
    let lista = options ? options.map(items => items.value) : []
    setQuery({
      ...query,
      filterFactories: lista.toString(),
    })
  }

  const templateHandleChange = options => {
    setBaseType(options?.alias)
    setSelectedDualList(options ? options?.fields : [])
  }

  const handleBatchFile = async offset => {
    try {
      if (!inputFile) return
      handleLoading(true)
      const payload = await postOrders(
        { batch: inputFile },
        query,
        offset,
        limit
      )
      const { orders, total } = payload
      const pages = total / limit + (total % limit > 0 ? 1 : 0)
      setOrders(orders)
      setPageOptions({ ...initPageOptions, totalSize: total })
      setTotal(total)
      setPages(Math.floor(pages))
      const { checkboxes } = await getCheckboxes()
      setCheckboxes(checkboxes)
    } catch (err) {
    } finally {
      handleLoading(false)
    }
  }

  const fetchFilters = async () => {
    try {
      const { statuses, couriers, UFs, factories, products } =
        await getOrderOptions()
      setStatuses(statuses)
      setCouriers(couriers)
      setUFs(UFs)
      setFactories(factories)
      setProducts(products)
    } catch (error) {
      console.error(error)
    }
  }

  const fetchOrders = async (filters, offset) => {
    try {
      const res = await getOrders(filters || query, offset, limit)
      const { orders, total } = res
      setOrders(orders)
      setPageOptions({ ...initPageOptions, totalSize: total })
      const pages = total / limit + (total % limit > 0 ? 1 : 0)
      setTotal(total)
      const currentPage = parseInt(filters ? filters.page || 1 : 1)
      setCurrentPage(currentPage)
      setPages(Math.floor(pages))
      setIsLastPage(currentPage === Math.floor(pages) ? true : false)
      setIsFirstPage(currentPage === 1 ? true : false)
      const { checkboxes } = await getCheckboxes()
      setCheckboxes(checkboxes)
    } catch (err) {
      console.log(err)
    } finally {
      handleLoading(false)
    }
  }

  const onQuery = e => {
    e.preventDefault()
    handleLoading(true)
    if (inputFile) {
      handleBatchFile(0)
    } else {
      query.page = 1
      setQuery(query)
      fetchOrders(query, 0)
      setCurrentPage(1)
      setIsFirstPage(true)
      history.push({
        pathname: location.pathname,
        search: `${objectToQueryString(query)}`,
      })
    }
  }

  const snapToPage = page => {
    const newPage = currentPage + page
    setCurrentPage(newPage)
    setIsFirstPage(newPage == 1 ? true : false)
    const offset = Math.floor(limit * (newPage - 1))
    setIsLastPage(newPage == pages ? true : false)
    handleLoading(true)
    query.page = newPage
    setQuery(query)
    fetchOrders(query, offset, false)
    history.push({
      pathname: location.pathname,
      search: `${objectToQueryString(query)}`,
    })
  }

  const fetchStatusSafra = async () => {
    try {
      const safra = await getStatusSafra()
      setStatusSafra(safra)
    } catch (error) {
      console.error(error)
    }
  }

  const fetchTemplates = async () => {
    if (user?.roleId) {
      const templates = await getTemplatesByRoleId(user.roleId)
      setTemplatesList(templates)
    }
  }

  useEffect(() => {
    fetchTemplates()
  }, [user])

  const templateOptions = templatesList?.map(t => {
    return {
      value: t.id,
      label: t.templateName,
      fields: JSON.parse(t.filters).filters,
      alias: t?.alias,
    }
  })

  useEffect(() => {
    setFileType("xlsx")
    setBaseType("atual")
    handleLoading(true)
    if (location.search) {
      const queries = location.search.replace(/^\?/, "").split("&")
      const query = {}
      queries.forEach(q => {
        let [name, value] = q.split("=")
        if (name === "startAt" || name === "endAt")
          value = moment(value, "YYYY-MM-DD").toDate()
        if (name === "clientName") value = value.replaceAll("%20", " ")
        query[name] = value
      })
      let offset = Math.floor(limit * ((query.page || 0) - 1))
      setQuery(query)
      setCurrentPage(parseInt(query.page || 1))
      fetchStatusSafra()
      fetchFilters()
      fetchOrders(query, offset, false)
    } else {
      fetchStatusSafra()
      fetchFilters()
      fetchOrders()
    }
  }, [])

  const updateStatusByAR = async AR => {
    handleLoading(true)
    try {
      await postUpdateStatusAR(AR)
      toast("success", "Pedido de Atualização realizado com sucesso.", "")
    } catch (error) {
      toast("warning", "Falha no pedido de Atualização.", "")
    } finally {
      if (inputFile) {
        handleBatchFile(0)
      } else {
        query.page = 1
        setQuery(query)
        fetchOrders(query, 0, false)
        setCurrentPage(1)
        setIsFirstPage(true)
        history.push({
          pathname: location.pathname,
          search: `${objectToQueryString(query)}`,
        })
      }
    }
  }

  const checkboxesOptions = checkboxes?.map(c => ({
    label: c.title,
    value: c.title,
  }))

  const [showExtra, setShowExtra] = useState(false)

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb
            title={props.t("Rastreios")}
            breadcrumbItems={[{ title: props.t("Rastreio"), path: "#" }]}
          />
          <Row>
            <Col>
              <Card className="mb-0 border-bottom">
                <CardHeader tag={"h5"} className="bg-transparent border-bottom">
                  <Row className="hstack">
                    <Col>Filtro</Col>
                    {orders.length > 0 && total <= 200000 && (
                      <Col>
                        <button
                          type="button"
                          className="btn btn-dark btn-block float-end"
                          disabled={orders.length === 0}
                          onClick={() => {
                            setExportModal(true)
                          }}
                        >
                          <i className="bx bx-export d-block"></i> Exportar
                        </button>
                      </Col>
                    )}

                    {orders.length > 0 && total > 200000 && (
                      <Col align="right">
                        <mark style={{ color: "red" }}>
                          <small>
                            Excedeu 200 mil resgistros para exportação!
                          </small>
                        </mark>
                      </Col>
                    )}
                  </Row>
                </CardHeader>
                <CardBody>
                  <Form className="form-horizontal" onSubmit={onQuery}>
                    <Row className="g-3">
                      <Col>
                        <Row>
                          <Col>
                            <FormGroup controlid="ordersStartDateRef">
                              <Label>Início</Label>
                              <DatePicker
                                dateFormat="dd/MM/yyyy"
                                className="form-control"
                                selected={query.startAt}
                                selectsStart
                                disabled={isLoading}
                                startDate={query.startAt}
                                endDate={query.endAt}
                                onChange={e => {
                                  setQuery({
                                    ...query,
                                    startAt: e,
                                  })
                                }}
                              />
                            </FormGroup>
                          </Col>
                          <Col>
                            <FormGroup controlid="ordersEndDateRef">
                              <Label>Fim</Label>
                              <DatePicker
                                dateFormat="dd/MM/yyyy"
                                className="form-control"
                                selected={query.endAt}
                                selectsEnd
                                disabled={isLoading}
                                startDate={query.startAt}
                                endDate={query.endAt}
                                onChange={e => {
                                  setQuery({
                                    ...query,
                                    endAt: e,
                                  })
                                }}
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                      </Col>
                      <Col>
                        <FormGroup controlid="ordersStatusRef">
                          <Label>Status</Label>
                          <Select
                            classNamePrefix="reactSelect"
                            isMulti
                            placeholder=""
                            closeMenuOnSelect={false}
                            value={selectedStatus}
                            isDisabled={isLoading}
                            options={statusOptions}
                            onChange={statusHandleChange}
                            menuPortalTarget={document.body}
                          />
                        </FormGroup>
                      </Col>
                      <Col>
                        <FormGroup controlid="ordersStatusRef">
                          <Label>Transportadora</Label>
                          <Select
                            classNamePrefix="reactSelect"
                            isMulti
                            placeholder=""
                            options={courierOptions}
                            closeMenuOnSelect={false}
                            isDisabled={isLoading}
                            onChange={courierHandleChange}
                            menuPortalTarget={document.body}
                          />
                        </FormGroup>
                      </Col>
                      <Col>
                        <FormGroup>
                          <Label>Prazo</Label>
                          <Select
                            classNamePrefix="reactSelect"
                            placeholder=""
                            options={[
                              { label: "Dentro", value: "DENTRO" },
                              { label: "Fora", value: "FORA" },
                            ]}
                            isClearable
                            closeMenuOnSelect={true}
                            isDisabled={isLoading}
                            onChange={e => {
                              setQuery({
                                ...query,
                                onTime: e,
                              })
                            }}
                            menuPortalTarget={document.body}
                          />
                        </FormGroup>
                      </Col>
                      <Col>
                        <div
                          className="h-100 hstack gap-3"
                          style={{
                            marginTop: "6px",
                          }}
                        >
                          <Button
                            type="submit"
                            color="primary"
                            className="w-100"
                          >
                            <i className="bx bx-search-alt align-middle"></i>{" "}
                            Filtrar
                          </Button>
                          <a
                            href="#"
                            onClick={() => {
                              setShowExtra(!showExtra)
                            }}
                            className="btn btn-secondary w-100"
                          >
                            <i className="bx bx-filter-alt align-middle"></i>{" "}
                            Avançado
                          </a>
                        </div>
                      </Col>
                    </Row>
                    <Collapse isOpen={showExtra}>
                      <Row className="g-3">
                        <Col sm={4}>
                          <FormGroup controlid="orderKeyRef">
                            <Label>Chave</Label>
                            <div className="col-md-12">
                              <Input
                                type="textarea"
                                maxLength="6000"
                                rows="10"
                                disabled={isLoading || inputFile}
                                value={query.refKey}
                                onChange={e => {
                                  setQuery({
                                    ...query,
                                    refKey: e.target.value,
                                  })
                                }}
                              />
                            </div>
                            <FormText className="text-muted">
                              Chave: AR <b>(Máximo de 400 linhas)</b>
                            </FormText>
                          </FormGroup>
                        </Col>
                        <Col sm={8}>
                          <Row>
                            <Col lg={8}>
                              <FormGroup controlid="orderKeyBatchRef">
                                <Label>Busca por lote (.csv)</Label>
                                <Input
                                  ref={batchInputRef}
                                  className="form-control"
                                  disabled={isLoading || query?.refKey != ""}
                                  type="file"
                                  accept=".csv,.txt"
                                  onChange={e => {
                                    setFile(e.target.files[0])
                                  }}
                                />
                                <FormText className="text-muted">
                                  Chave: AR
                                </FormText>
                              </FormGroup>
                            </Col>
                            <Col lg={2}>
                              <FormGroup controlid="ordersEndDateRef">
                                <Label>CEP Início</Label>
                                <Input
                                  type="search"
                                  value={query.cepInicio}
                                  disabled={isLoading}
                                  onChange={e => {
                                    setQuery({
                                      ...query,
                                      cepInicio: e.target.value,
                                    })
                                  }}
                                />
                              </FormGroup>
                            </Col>
                            <Col lg={2}>
                              <FormGroup controlid="ordersEndDateRef">
                                <Label>CEP Fim</Label>
                                <Input
                                  type="search"
                                  value={query.cepFim}
                                  disabled={isLoading}
                                  onChange={e => {
                                    setQuery({
                                      ...query,
                                      cepFim: e.target.value,
                                    })
                                  }}
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              <FormGroup controlid="ordersStatusRef">
                                <Label>St Visão Safra</Label>
                                <Select
                                  classNamePrefix="reactSelect"
                                  isMulti
                                  placeholder=""
                                  options={statusSafraOptions}
                                  closeMenuOnSelect={false}
                                  isDisabled={isLoading}
                                  onChange={statusSafraHandleChange}
                                  menuPortalTarget={document.body}
                                />
                              </FormGroup>
                            </Col>
                            <Col>
                              <FormGroup controlid="ordersStatusRef">
                                <Label>UF</Label>
                                <Select
                                  classNamePrefix="reactSelect"
                                  isMulti
                                  placeholder=""
                                  options={ufOptions}
                                  closeMenuOnSelect={false}
                                  isDisabled={isLoading}
                                  onChange={ufHandleChange}
                                  menuPortalTarget={document.body}
                                />
                              </FormGroup>
                            </Col>
                            <Col>
                              <FormGroup controlid="ordersStatusRef">
                                <Label>Fábrica</Label>
                                <Select
                                  classNamePrefix="reactSelect"
                                  isMulti
                                  placeholder=""
                                  options={factoriesOptions}
                                  closeMenuOnSelect={false}
                                  isDisabled={isLoading}
                                  onChange={factoriesHandleChange}
                                  menuPortalTarget={document.body}
                                />
                              </FormGroup>
                            </Col>
                            <Col>
                              <FormGroup controlid="ordersStatusRef">
                                <Label>Cliente</Label>
                                <Input
                                  type="text"
                                  value={query.clientName}
                                  disabled={isLoading}
                                  onChange={e => {
                                    setQuery({
                                      ...query,
                                      clientName: e.target.value,
                                    })
                                  }}
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              <FormGroup controlid="ordersStatusRef">
                                <Label>Produtos</Label>
                                <Select
                                  classNamePrefix="reactSelect"
                                  isMulti
                                  placeholder=""
                                  options={productsOptions}
                                  closeMenuOnSelect={false}
                                  isDisabled={isLoading}
                                  onChange={productHandleChange}
                                  menuPortalTarget={document.body}
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Collapse>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col>
              <Card>
                <CardHeader tag={"h5"} className="bg-transparent border-bottom">
                  Resultado
                </CardHeader>
                <CardBody>
                  {!isLoading &&
                    (orders.length > 0 ? (
                      <PaginationProvider
                        pagination={paginationFactory(pageOptions)}
                        keyField="id"
                        columns={columns}
                        data={orders}
                      >
                        {({ paginationTableProps }) => (
                          <ToolkitProvider
                            keyField="id"
                            columns={columns}
                            columnToggle
                            data={orders}
                            search
                          >
                            {toolkitProps => (
                              <React.Fragment>
                                <Row>
                                  <Col xl="12" className="table-responsive">
                                    {/* <div className="table-responsive"> */}
                                    <BootstrapTable
                                      keyField={"id"}
                                      bordered={true}
                                      striped={true}
                                      condensed
                                      defaultSorted={defaultSorted}
                                      selectRow={selectRow}
                                      classes={
                                        "table table-sm align-middle table-nowrap"
                                      }
                                      headerWrapperClasses={"thead-light"}
                                      {...toolkitProps.baseProps}
                                      {...paginationTableProps}
                                    />
                                    {/* </div> */}
                                  </Col>
                                </Row>

                                {total > 0 && (
                                  <Row className="align-items-md-center mt-30">
                                    <Col className="inner-custom-pagination d-flex">
                                      <div className="d-inline">
                                        <span className="react-bootstrap-table-pagination-total">
                                          Registros Retornados: {total}
                                        </span>
                                      </div>
                                      <div className="text-md-right ms-auto">
                                        <button
                                          className="btn btn-outline-primary "
                                          disabled={isFirstPage}
                                          onClick={() => snapToPage(-1)}
                                        >
                                          Anterior
                                        </button>
                                        <button
                                          className="btn btn-outline-primary"
                                          disabled
                                        >
                                          {currentPage}/{pages}
                                        </button>
                                        <button
                                          className="btn btn-outline-primary "
                                          disabled={isLastPage}
                                          onClick={() => snapToPage(1)}
                                        >
                                          Próximo
                                        </button>
                                      </div>
                                    </Col>
                                  </Row>
                                )}
                              </React.Fragment>
                            )}
                          </ToolkitProvider>
                        )}
                      </PaginationProvider>
                    ) : (
                      <div style={{ textAlign: "center" }}>
                        <h5>Nenhum dado foi encontrado.</h5>
                      </div>
                    ))}
                  {isLoading && (
                    <div
                      className="accordion-body"
                      style={{ textAlign: "center" }}
                    >
                      <Spinner className="ms-2" color="primary" />
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      <Modal
        isOpen={exportModal}
        size="lg"
        toggle={() => {
          toggleModal()
        }}
        onClosed={() => {
          setSelectedDualList([])
        }}
        centered
      >
        <ModalHeader>
          Exportação de Dados
          <button
            type="button"
            onClick={() => {
              setExportModal(false)
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col>
              <div className="form-group">
                <label htmlFor="key" style={{ textAlign: "left" }}>
                  Exportar como:
                </label>
                <div className="form-row ml-0">
                  <div className="form-group form-check ml-2">
                    <input
                      className="form-check-input"
                      name="fileType"
                      value="xlsx"
                      id="xlsType"
                      type="radio"
                      checked={fileType === "xlsx"}
                      onChange={e => {
                        setFileType(e.target.value)
                      }}
                    />
                    <label htmlFor="xlsType"> Excel </label>
                  </div>
                </div>
              </div>
            </Col>
            <Col>
              <Select
                isClearable={true}
                classNamePrefix="react-select"
                options={templateOptions}
                placeholder={"Template"}
                onChange={templateHandleChange}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <DualListBox
                className="custom-dual-listbox"
                options={checkboxesOptions}
                canFilter
                preserveSelectOrder
                showOrderButtons
                showHeaderLabels
                lang={{
                  availableFilterPlaceholder: "Campos Selecionáveis",
                  selectedFilterPlaceholder: "Campos Selecionados",
                  moveAllToAvailable: "Mover todos para Selecionáveis",
                  moveAllToSelected: "Mover todos para Selecionados",
                  moveToAvailable: "Mover para Selecionável",
                  moveToSelected: "Mover para Selecionado",
                  moveBottom: "Mover para Final da Lista",
                  moveDown: "Mover uma posição para Baixo",
                  moveUp: "Mover uma posição para Cima",
                  moveTop: "Mover para Início da Lista",
                  availableHeader: "",
                  selectedHeader:
                    "Ordem dos Campos influencia na ordem das Colunas do Arquivo",
                }}
                selected={selectedDualList}
                onChange={newValue => setSelectedDualList(newValue)}
              />
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => {
              setExportModal(false)
            }}
          >
            Cancelar
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => {
              generateExport()
            }}
          >
            Gerar Exportação
          </button>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  )
}

Rastreio.propTypes = {
  t: PropTypes.any,
}

export default withTranslation()(Rastreio)
